import queryFn from "ApiLayer/Reports/Recommendations/queryAnnualCarbonEmissionsNaturalGasChart";
import { useAccessToken } from "hooks/useAccessToken";
import { useQuery } from "react-query";
import { QUERY_STALE_TIME } from "utils/constants";

export const useAnnualCarbonEmissionsNaturalGasChart = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["recommendationsAnnualCarbonEmissionsNaturalGasChart", filtersetUid],
        queryFn: async () => queryFn(accessToken, { reportFiltersetUid: filtersetUid }),
        staleTime: QUERY_STALE_TIME,
    });
};
